// @ts-nocheck
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import { TABLET_WIDTH } from 'commons/constants';

const {
  noodera: { spacing },
  gradients,
  boxShadow,
} = getTheme();
const GoTopWrapper: StatelessFunctionalComponent<any> = styled.div`
  align-content: center;
  background: ${gradients.noodera};
  border-radius: 5rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 4.8rem;
  position: fixed;
  left: ${spacing.x5};
  bottom: ${spacing.x1};
  justify-content: center;
  width: 4.8rem;
  z-index: 999;
  box-shadow: ${boxShadow.default};
  scroll-behavior: smooth;

  .go-top {
    display: block;

    &__progress-ring {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    &__icon {
      text-align: center;
    }
  }

  .arrow {
    align-self: center;
    color: white;
    font-size: 2rem;
    font-weight: 700;
  }

  @media screen and (max-width: ${TABLET_WIDTH}px) {
    bottom: 144px;
    right: 12px;
    left: auto;
  }
`;
export default GoTopWrapper;
